const Address = () => (
  <section className="centered-section">
  <div className="translucent-box" >
  <h2 className="main-heading">Send Your Knives To:</h2>
    <address className="styled-address">
        Golden Edge Sharpening Service<br />
        16198 E Schaeffer St<br />
        Bayview, ID 83803<br />
        <br />
        Please include your contact info and return address with your shipment.
        </address>
    </div>
  </section>
);

export default Address;
